// WorkDetails.jsx
import React, { useState } from "react";

function WorkDetails() {
  const [jobType, setJobType] = useState("");
  const [employmentType, setEmploymentType] = useState("");

  return (
    <div className="mb-4">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        Work Details
      </h2>
     
      {/* Show candidates seeking */}
      <div className="mb-6">
        <label className="block text-gray-700 font-semibold mb-2">
          Show candidates seeking
        </label>
        <div className="flex gap-4">
          <select
            value={jobType}
            onChange={(e) => setJobType(e.target.value)}
            className="w-full border rounded-md py-2 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Job type</option>
            <option value="full-time">Full-Time</option>
            <option value="part-time">Part-Time</option>
            <option value="freelance">Freelance</option>
            <option value="internship">Internship</option>
          </select>

          <select
            value={employmentType}
            onChange={(e) => setEmploymentType(e.target.value)}
            className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Employment type</option>
            <option value="permanent">Permanent</option>
            <option value="contract">Contract</option>
            <option value="temporary">Temporary</option>
          </select>
        </div>
      </div>

      
      {/* Work permit for */}
      {/* <div className="mb-4">
        <label className="block text-gray-700 font-semibold mb-2">
          Work permit for
        </label>
        <select
          value={workPermit}
          onChange={(e) => setWorkPermit(e.target.value)}
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Choose category</option>
          <option value="us">United States</option>
          <option value="canada">Canada</option>
          <option value="europe">Europe</option>
          <option value="australia">Australia</option>
        </select>
      </div> */}
    </div>
  );
}

export default WorkDetails;
